import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/mhN9KYKgvLcn6dXCYqdq7k/DPS26-mockup-cuadernillos-3x2.png';
const chips = ['6 Volumes', '90 Practices', '300 Pages', '90 · 75 · 60-min', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or run it from your phone'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-plum-deep" data-id="element-109" data-mp="1274odq5sli7r">
      <div className="relative mx-auto max-w-6xl px-5 pb-14 pt-8 md:pb-20 md:pt-12" data-id="element-110" data-mp="xaxe5l6d5kk0">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-111" data-mp="s9zzhikkb8n9">
          <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-112" data-mp="nb6kflpmn9kz">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-113" data-mp="3d1a8vl7kyddt">
              The Two-Track Practice System · for wrestling coaches
            </p>
            <h1 className="mt-3 font-display font-semibold uppercase text-white text-[34px] leading-[1.05] tracking-tight sm:text-[42px] md:text-6xl lg:text-[64px]" data-id="element-114" data-mp="384jq2q4e53op">
              Your whole season of wrestling practices,{' '}
              <span className="text-gold" data-id="element-115" data-mp="39al869qleg11">already planned.</span>
            </h1>
          </div>

          {/* Product image: right after the headline on mobile, right column on desktop */}
          <figure className="lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-116" data-mp="30i15my76jrax">
            <img src={HERO_IMAGE} alt="The six Wrestling Practice Ready volumes laid out on a coach's table beside a wrestling mat" width={2048} height={1360} className="mx-auto w-full max-w-[640px] rounded-xl object-cover shadow-cover ring-1 ring-plum-line lg:max-w-none" data-id="element-117" data-mp="30fy8zvbiuzx8" />
          </figure>

          <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-118" data-mp="2hjoz7k7nkvj1">
            <p className="max-w-xl text-base text-white/75 md:text-lg" data-id="element-119" data-mp="2ll0fv08ju6f3">
              Six volumes with 90 numbered, ready-to-run practices, timed minute
              by minute, with a Rookie track and a Returner track on the same
              clock. Open the practice, pick your clock, run it.
            </p>

            <div className="mt-6 w-full md:max-w-md" data-id="element-120" data-mp="id03goyxw2nl">
              <CtaButton data-id="element-121" data-mp="dd5ews2mzp5p">Get Wrestling Practice Ready</CtaButton>
            </div>

            <div className="mt-5 flex justify-center lg:justify-start" data-id="element-122" data-mp="dbapb0gf78va">
              <RatingProof data-id="element-123" data-mp="1b0dt020b5vxo" />
            </div>

            <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-124" data-mp="1622idp26vhee">
              {chips.map(chip => <li key={chip} className="rounded-md border border-plum-line bg-plum px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/75" data-id="element-125" data-mp="111ok2yqe3ltk">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center border-t border-plum-line pt-6" data-id="element-126" data-mp="3hpsff7k1zv33">
          <p className="max-w-md text-center text-sm text-white/70" data-id="element-127" data-mp="1xam4cnf59kxc">
            Written for head coaches, assistants, club volunteers and PE
            teachers who run their own practices. Folkstyle-first, with
            freestyle notes. No subscription.
          </p>
          <ul className="mt-4 flex flex-col items-center gap-2 text-xs text-white/60 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-128" data-mp="2b0zduu7op7os">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="2kyn9dmd46j80">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-130" data-mp="2l101utgi0bzb" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}